// Largely modified version of jquery.tinyscrollbar
define(function (require) {
    "use strict";

    var $       = require("jquery"),
        KeyCode = require("shared/services/KeyCode"),
        Browser = require("shared/services/Browser");

    var pluginName      = "tinyscrollbar",
        $document       = $(document),
        wheelEvent      = ("onwheel" in document || document.documentMode >= 9) ? "wheel" :
                            (document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll"),

        defaults   = {
            axis            : "y",    // Vertical or horizontal scrollbar? ( x || y ).
            wheel           : true,   // Enable or disable the mousewheel;
            wheelLock       : true,   // Lock default scrolling window when there is no more content.
            scrollInvert    : false,  // Enable invert style scrolling
            trackSize       : false,  // Set the size of the scrollbar to auto or a fixed number.
            extraContentSize: 0,       // any extra content size that isn't positioned within the layout, but we should take into account when calculating the content size. Example: absolutely positioned content
            contentPosition : 0,
            contentOffset   : 0
        };

    // Constructor
    function TinyScrollbar ($viewport, options) {

        this.options   = $.extend({}, defaults, options);
        this.disable   = false;

        var self          = this,
            $scrollbar    = this.options.scrollbar,
            $overview     = $viewport.find(".overview"),
            $scrollTarget = $overview.find(".scroll-target"),
            $track        = $scrollbar.find(".track"),
            $bar          = $scrollbar.find(".bar"),

            isSpacePressed = false,
            isBarDragged   = false,
            isDragged      = false,
            isHorizontal   = this.options.axis === "x",
            sizeLabel      = isHorizontal ? "width" : "height",
            positionLabel  = isHorizontal ? "left" : "top",
            sizeLabelCap   = isHorizontal ? "Width" : "Height",

            startPosition   = 0,
            prevPosition    = 0,
            contentPosition = 0,
            viewportSize    = 0,
            contentSize     = 0,
            contentRatio    = 0,
            trackRatio      = 0,
            barSize         = 0,
            trackSize       = this.options.trackSize,

            maxContentPosition = contentSize - viewportSize;

        function initialize () {
            attachEventListeners();
            compute();

            // Normalize the position to beginning for all browsers, fix for Firefox
            $overview.css(positionLabel, 0);

            // Initialize scroll bar
            $scrollbar.css(sizeLabel, trackSize);
            $track.css(sizeLabel, trackSize);

            return self;
        }

        // limit the position within the range 0~max, max should not be negative
        // This is to ensure that content should always be set in a valid position
        function limit(position) {
            return Math.round(Math.min(Math.max(0, maxContentPosition), Math.max(0, position)));
        }

        // Need recompute after resize of content or window (getBoundingClientRect takes scale into account)
        function compute () {
            viewportSize = $viewport[0]["offset"+ sizeLabelCap];
            contentSize  = $scrollTarget[0].getBoundingClientRect()[sizeLabel] + self.options.extraContentSize;
            contentRatio = viewportSize / contentSize;
            barSize      = trackSize * contentRatio;
            trackRatio   = contentSize / trackSize;
            maxContentPosition = contentSize - viewportSize;

            $bar.css(sizeLabel, barSize);
            self.disable = contentRatio >= 1;
            $scrollbar.toggleClass("disable", self.disable);
        }

        function attachEventListeners () {
            $bar.bind("mousedown", start);
            $track.bind("mousedown", click);
            $scrollTarget.bind("mousedown", start);

            // Jquery resize event name has been changed to cresize, because with "resize" name, when the event is
            // triggered on element, it will propagate and invoke the window resize, which is not necessary.
            $scrollTarget.on("cresize", self.update);
            $(window).resize(self.update);

            // scroll events
            if (self.options.wheel) {
                if(window.addEventListener) {
                    $viewport[0].addEventListener(wheelEvent, wheel, false);
                } else {
                    $viewport[0].onmousewheel = wheel;
                }
            }

            // Add pannable css
            $document.keydown(function(evt) {
                if (evt.which === KeyCode.SPACE && !isSpacePressed && !$(document.activeElement).is("input, textarea")) {
                    $scrollTarget.addClass("pannable");
                    isSpacePressed = true;
                }
            });

            $document.keyup(function(evt) {
                if (evt.which === KeyCode.SPACE) {
                    $scrollTarget.removeClass("pannable");
                    isSpacePressed = false;
                }
            });
        }

        // Start dragging event
        function start(event) {
            startPosition = isHorizontal ? event.pageX : event.pageY;
            isBarDragged  = $(event.target).is($bar);
            isDragged     = false;

            $document.bind("mousemove", drag);
            $document.bind("mouseup", end);

            // We can not just prevent default here without condition, because the textWidget needs
            // mouse event to blur editing mode
            if (isSpacePressed || isBarDragged) {
                event.preventDefault();
            }
        }

        function setPosition (position, shouldAnimate) {
            // Event triggered at the end of the position move.
            // Triggered on the scrollbar element. (MOS-2553)
            var onCompletedMovePosition = function(){
                $bar.trigger("move");
            };

            // Event triggered at the start of a position move.
            // Only fires if previous position is different to new position
            var onStartMoving = function (){
                $bar.trigger("startMove");
            };

            position = limit(position);

            self.options.contentOffset = position;

            $overview.stop(true, true);

            if(prevPosition !== position){
                onStartMoving();
            }

            if (shouldAnimate) {
                var animateParam = {};
                animateParam[positionLabel] = "-=" + (position - prevPosition);
                $overview.animate(animateParam, {
                    duration: 200,
                    complete: onCompletedMovePosition
                });
            } else {
                $overview.css(positionLabel, -position);
                onCompletedMovePosition();
            }

            // update bar position
            $bar.css(positionLabel, position / trackRatio);

            // store the position to compute offset for animation
            prevPosition = position;
        }

        this.update = function () {
            compute();

            // Only when position is invalid, we need to update the position
            if (contentPosition !== limit(contentPosition)) {
                contentPosition = limit(contentPosition);
                setPosition(contentPosition);
            }

            return self;
        };

        /**
         * Scroll to a position
         * @param scrollTo
         * @param value
         * @param shouldUpdate   should the scroll bar be recomputed before scroll
         * @param shouldAnimate  should scroll with animation
         */
        this.scrollTo = function (scrollTo, value, shouldUpdate, shouldAnimate) {
            if (shouldUpdate) {
                compute();
            }

            switch (scrollTo) {
            case "beginning":
                contentPosition = 0;
                break;

            case "absolute":
                contentPosition = parseInt(value, 10) || 0;
                break;

            case "offset":
                contentPosition -= value;
                break;

            case "center":
                contentPosition = value - viewportSize / 2;
                break;

            case "relative":
                break;
            case "visible":
                const scrollBarSizeOffset = 60;
                const scrollBottom = viewportSize + contentPosition - scrollBarSizeOffset;
                if (value > scrollBottom) {
                    const scrollDelta = value - scrollBottom + scrollBarSizeOffset;
                    contentPosition = scrollDelta + contentPosition;
                }
                break;
            default:
                // contentPosition = scrollTo;
                break;
            }

            contentPosition = limit(contentPosition);
            setPosition(contentPosition, shouldAnimate);
        };

        // Mouse wheel or touchpad scroll event
        function wheel (event) {
            if (event.shiftKey) {
                $scrollTarget.trigger("scrollToZoom", event);
                event.preventDefault();
                return;
            }

            if (self.disable) {
                return;
            }

            var scallbarV      = $viewport.data("tinyscrollbar").y,
                isScollbarVOn  = scallbarV && !scallbarV.disable,
                _axis      = self.options.axis.toUpperCase(),
                evntObj    = event || window.event,
                deltaDir   = "delta" + _axis,
                deltaY     = "deltaY",
                deltaSpeed = 0;

            // If we don't have a vertical scroll bar and users scroll vertically on touchpad,
            // we fall it back to horizontal scroll action
            if (evntObj[deltaDir] !== undefined) {
                deltaSpeed = evntObj[deltaDir] || (_axis === "X" && !isScollbarVOn && evntObj[deltaY]);
            } else if (evntObj.wheelDelta !== undefined) {
                deltaDir = "wheelDelta" + _axis;
                deltaY   = "wheelDeltaY";
                deltaSpeed = evntObj[deltaDir] || (_axis === "X" && !isScollbarVOn && evntObj[deltaY]);
                deltaSpeed = deltaSpeed / 3;
            } else if (evntObj.detail) {
                deltaSpeed = evntObj.detail;
            }

            // FF in windows need to compensate the speed.
            if (navigator.platform.indexOf("Win")!== -1 && Browser.capabilities.browser.firefox) {
                deltaSpeed *= 7;
            }

            self.scrollTo("offset", -deltaSpeed, false, false);
            event.preventDefault();
        }

        // Dragging bar or content event
        function drag (event) {
            if (!isBarDragged && !isSpacePressed) {
                return;
            }

            isDragged = true;
            var mousePositionNew   = isHorizontal ? event.pageX : event.pageY,
                moveDelta = mousePositionNew - startPosition,
                barPositionNew,
                contentPositionNew;

            if(isBarDragged) {
                barPositionNew     = contentPosition / trackRatio + moveDelta;
                contentPositionNew = barPositionNew * trackRatio;
            } else {
                contentPositionNew = contentPosition - moveDelta;
            }

            setPosition(contentPositionNew, false);
            event.preventDefault();
        }

        // Click on track event
        function click (event) {
            if (!($(event.target).is($track))) {
                return;
            }

            var posX = $track.offset().left,
                posY = $track.offset().top,
                barPosition = (isHorizontal ? event.pageX - posX : event.pageY - posY) - barSize / 2;

            contentPosition = barPosition * trackRatio;
            self.scrollTo("absolute", contentPosition, false, false);
        }

        function end () {
            $document.unbind("mousemove", drag);
            $document.unbind("mouseup", end);

            if (isDragged) {
                // Update the final position after dragging
                contentPosition = -parseInt($overview.css(positionLabel), 10) || 0;
            }
        }

        return initialize();
    }

    // Plugin definition
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            var scrollbars = $.data(this, pluginName) || {};
            scrollbars.x = options.x && new TinyScrollbar($(this), $.extend({axis: "x"}, options.x));
            scrollbars.y = options.y && new TinyScrollbar($(this), $.extend({axis: "y"}, options.y));
            $.data(this, pluginName, scrollbars);
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/editor/vendor/jquery.tinyscrollbar.js
// module id = 2757
// module chunks = 0